import { useFormikContext } from 'formik'

import { isEmptyString } from '../../../../../utils/common'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
} from '../../EmailCreationForm.constants'
import {
  isEmailCreationFormAvailablePreview,
  isEmailCreationFormAvailableTestVariables,
} from '../../EmailCreationForm.utils'

import { getMassEmailEffectiveRecipientCount } from './useMoreActionsAvailability.utils'

export function useMoreActionsAvailability({
  blackList,
  blocked,
  disableDuplicateRecipientsValidation = false,
  docTemplates,
  isAvailablePreview = isEmailCreationFormAvailablePreview,
  isAvailableTestVariables = isEmailCreationFormAvailableTestVariables,
  mass,
  noActiveAccounts,
  printer,
}) {
  const { values } = useFormikContext()

  const baseRecipientsCount = values[EMAIL_CREATION_FORM_FIELD_NAME_TO].filter(
    i => !isEmptyString(i.value)
  ).length

  const recipientsCount =
    mass && !disableDuplicateRecipientsValidation
      ? getMassEmailEffectiveRecipientCount({ blackList, printer, values })
      : baseRecipientsCount

  const emptyAccountField =
    noActiveAccounts || !values[EMAIL_CREATION_FORM_FIELD_NAME_FROM]

  const emptyRecipients = recipientsCount === 0

  const hasDocTemplates = docTemplates.length > 0

  const availableTestVariables = isAvailableTestVariables({
    emptyAccountField,
    emptyRecipients,
    hasDocTemplates,
    mass,
    values,
  })

  const availablePreview = isAvailablePreview({
    emptyAccountField,
    emptyRecipients,
    hasDocTemplates,
    mass,
  })

  return {
    availableMore: (mass || hasDocTemplates) && !blocked,
    availablePreview,
    availableTestVariables,
    emptyAccountField,
    emptyRecipients,
    recipientsCount,
  }
}
